import React, { useEffect, useState } from 'react';
import { message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import OrdersTable from '../../components/ordersTable/OrdersTable';
import { fetchOrders } from '../../redux/orders/actionCreator';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api';

const OrdersHistory = () => {
  const { loading } = useSelector(state => state.orders);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [state, setState] = useState({ loadingScreen: false });

  useEffect(() => {
    dispatch(fetchOrders({ history: true, page: pageNumber }));
  }, [pageNumber, dispatch]);

  const handleOnChangePageNumber = number => {
    setPageNumber(number);
  };

  const handleOnDeleteOrder = async idToRemove => {
    setState({
      ...state,
      loading: true,
    });

    DataService.delete(`${API.pos.orders}/${idToRemove}`)
      .then(_data => {
        message.success('Orden Eliminada');
        setState({ ...state, loading: false });
        dispatch(fetchOrders({ history: true, page: pageNumber }));
      })
      .catch(_err => {
        setState({ ...state, loading: false });
      });
  };

  const handleOnRePrintOrder = async idToPrint => {
    setState({
      ...state,
      loading: true,
    });

    DataService.post(`${API.pos.orders}/${idToPrint}/print`, {})
      .then(_data => {
        message.success('Orden Enviada A Imprimir');
        setState({ ...state, loading: false });
        dispatch(fetchOrders({ history: true, page: pageNumber }));
      })
      .catch(_err => {
        setState({ ...state, loading: false });
      });
  };

  return (
    <>
      {loading ? (
        <Spin size="large" />
      ) : (
        <OrdersTable
          pageNumber={pageNumber}
          onChangePageNumber={handleOnChangePageNumber}
          onDeleteOrder={handleOnDeleteOrder}
          onRePrintOrder={handleOnRePrintOrder}
        />
      )}
    </>
  );
};

export default OrdersHistory;
